import type { ApplicationConfig } from './ApplicationConfig';
import { Stage } from './ApplicationConfig';

export const stagingConfig: ApplicationConfig = {
  apiUrl: 'https://staging-api.skin-seoul.com',
  csAgentApiUrl: 'https://staging-agent.skin-seoul.com',
  internalApiUrl: 'https://staging.internal-api.skin-seoul.work',
  googleOAuthClientId: '639007308170-lcrsao9lgj3km159oo6uj2sjhs8tbrb8.apps.googleusercontent.com',
  apiKey: '75dd554a-2b38-4774-807d-a3d1a870c9e7',
  stage: Stage.STAGING,
  sheetId: '16-wNHHRraJvvOdEG41IdOavPS7TMYwj8d4T0RHKtnFE',
  wpAdminUrl: 'https://staging.skin-seoul.com/wp-admin/',
  adminUrl: 'https://staging.admin.skin-seoul.work',
  n8nWebhookBaseUrl: 'https://dev-n8n.skin-seoul.work', // No dedicated staging n8n instance; intentionally shares dev
  slackTeamId: 'T06CKAJHMRU',
  logtoEndpoint: 'https://dev-auth.skin-seoul.com',
  logtoAppId: '9k0wksyunhb1wpkkppc5s',
  logtoStaffOrganizationId: 'qbhhenj8k9z0',
};
